export default "__VITE_ASSET__qZZZ7EOcQU0bnm2SE9d1Ig__"